export const EXPORT_PARAM = 'export';
export const EXPORT_WAREHOUSE_PARAM = 'exportWarehouseId';
export const EXPORT_RESIDENT_GROUP_PARAM = 'exportResidentGroup';
export const EXPORT_RESIDENT_PARAM = 'exportResidentId';
export const EXPORT_MEDICATION_SCOPE_PARAM = 'exportMedicationScope';
export const EXPORT_HEALTH_LOG_METRIC_PARAM = 'exportMetricId';

export const EXPORT_PARAMS = [
  EXPORT_PARAM,
  EXPORT_WAREHOUSE_PARAM,
  EXPORT_RESIDENT_GROUP_PARAM,
  EXPORT_RESIDENT_PARAM,
  EXPORT_MEDICATION_SCOPE_PARAM,
  EXPORT_HEALTH_LOG_METRIC_PARAM,
];
